import { endPoints } from 'api/';
import { GET_INTEGRATION } from 'actions/types';

export function getIntegration(companyId) {
  const query = { where: { company_id: companyId } };
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_INTEGRATION,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.GET_INTEGRATION, {}, query);
      },
    };
    dispatch(action);
  };
}
